import { CSRFToken, CSRF_TOKEN_HEADER } from '@tanium-cloud/tsp-contracts';
import { AxiosResponse } from 'axios';
import { getApiClient } from '../apiClient';

export const getCSRFToken = async (): Promise<string> => {
  const savedToken = sessionStorage.getItem(CSRF_TOKEN_HEADER);
  if (savedToken) {
    const token = JSON.parse(savedToken) as CSRFToken;
    return token.token;
  }
  return setCSRFToken();
};

/*
  Update the CSRF token stored in the browser session. An updated token can be found in
  the `X-CSRF-TOKEN` header of responses to POST, PUT, or DELETE requests.
 */
export const updateCSRFToken = (res: AxiosResponse): void => {
  const token = (res.headers as Record<string, string>)[CSRF_TOKEN_HEADER];
  if (token !== undefined && token !== '') {
    sessionStorage.setItem(
      CSRF_TOKEN_HEADER,
      JSON.stringify({
        token,
        logoutUrl: '',
      })
    );
  }
};

const setCSRFToken = async (): Promise<string> => {
  const apiClient = getApiClient();
  const response = await apiClient.get<CSRFToken>('/api/csrf');

  const token = response.data;
  sessionStorage.setItem(CSRF_TOKEN_HEADER, JSON.stringify(response.data));

  return token.token;
};

export const removeCSRFToken = (): void => {
  sessionStorage.removeItem(CSRF_TOKEN_HEADER);
};
